var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { fetchFromCMS, camelCaseKeys } from '~/helpers/page-data-utils';
// eslint-disable-next-line complexity
function replaceImageNumbersWithImageData(data) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof data.image === 'number') {
            const json = yield fetchFromCMS(`images/${data.image}`);
            data.image = json.file || (json.meta || {}).download_url;
        }
        for (const prop of Reflect.ownKeys(data)) {
            if (typeof data[prop] === 'object' && data[prop] !== null) {
                yield replaceImageNumbersWithImageData(data[prop]);
            }
        }
    });
}
function fetchDataAndExpandImages(slug, preserveWrapping) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield fetchFromCMS(slug, preserveWrapping);
        yield replaceImageNumbersWithImageData(data);
        return data;
    });
}
export function fetchPageData(slug, preserveWrapping, noCamelCase) {
    const camelCaseOrNot = noCamelCase ? (obj) => obj : camelCaseKeys;
    return fetchDataAndExpandImages(slug, preserveWrapping).then(camelCaseOrNot);
}
export default function usePageData(slug, preserveWrapping = false, noCamelCase = false) {
    const [data, setData] = React.useState();
    React.useEffect(() => {
        fetchPageData(slug, preserveWrapping, noCamelCase).then(setData);
    }, [slug, preserveWrapping, noCamelCase]);
    return data;
}
